// extracted by mini-css-extract-plugin
module.exports = {"section":"images-module--section--tVWNf","image":"images-module--image--225Jq"};